import { createPortal } from 'react-dom';
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';

/** Debe coincidir con NAVBAR_HEIGHT_PX en AppRouter (navbar fijo z-index 1000) */
const NAVBAR_OFFSET_PX = 68 + 16;

/** Por encima del navbar, barras fijas y dropdowns de la búsqueda */
const MODAL_Z = 10050;

export default function SharedModal({ open, setOpen, title, content }) {
  const handleClose = () => {
    if (typeof setOpen === 'function') {
      setOpen(false);
    }
  };

  if (typeof document === 'undefined') {
    return null;
  }

  return createPortal(
    <Dialog open={!!open} onClose={handleClose} style={{ position: 'relative', zIndex: MODAL_Z }}>
      <DialogBackdrop className="fixed inset-0 bg-slate-900/40" style={{ zIndex: MODAL_Z }} />
      <div className="fixed inset-0 overflow-y-auto" style={{ zIndex: MODAL_Z }}>
        <div
          className="flex min-h-full items-end justify-center p-4 pb-6 text-center sm:items-center sm:px-4 sm:pb-8"
          style={{ paddingTop: `max(1rem, ${NAVBAR_OFFSET_PX}px)` }}
        >
          <DialogPanel className="modal-tailwind relative z-[1]">
            <div className="bg-white px-4 pt-4 pb-4 sm:p-6 sm:pb-4">
              <button
                type="button"
                onClick={handleClose}
                className="absolute top-3 right-3 inline-flex justify-end rounded-md text-sm font-semibold text-black"
              >
                <XMarkIcon className="h-5 w-5 text-black" />
              </button>
              <DialogTitle as="div" className="text-lg font-semibold">
                {title}
              </DialogTitle>
              <div>{content}</div>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>,
    document.body,
  );
}
